'use client';

import { Database } from 'lucide-react';

interface AmsConnectCompleteModalProps {
  onFinish: () => void;
}

export function AmsConnectCompleteModal({ onFinish }: AmsConnectCompleteModalProps) {
  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="AMS connection tour complete"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal card */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 p-8">
        {/* Icon */}
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent-blue/[0.08]">
          <Database className="h-8 w-8 text-accent-blue" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">
          Your AMS Is Connected
        </h2>

        {/* Content */}
        <div className="text-left space-y-4 mb-8">
          <p className="text-base leading-relaxed text-gray-500">
            Voley is now linked to your Agency Management System. From here,
            everything stays in sync automatically.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">What happens next:</strong> Any client
              added or edited in your AMS will automatically update inside Voley. New
              contacts appear without manual entry, and changes to existing client details
              &mdash; names, phone numbers, addresses &mdash; are reflected right away.
            </p>
          </div>
          <p className="text-sm leading-relaxed text-gray-500">
            You can manage your connection settings and view sync history anytime from
            Settings &rarr; Integrations.
          </p>
        </div>

        {/* Finish button */}
        <div className="flex justify-center">
          <button
            onClick={onFinish}
            aria-label="Finish tour"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-base font-semibold text-white bg-accent-blue hover:brightness-110 transition-all shadow-md"
          >
            Finish Tour
          </button>
        </div>
      </div>
    </div>
  );
}
